module.exports = __webpack_public_path__ + "images/emoji/u6307.2054ed777dd4e02dbdb3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u6307.png
// module id = 8/GV
// module chunks = 1